<template>
  <svg class="room-icon-svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <template v-if="type === 'PERSONAL'">
      <path d="m7 23 17-14 17 14" />
      <path d="M11 21v19h26V21M20 40V29h8v11" />
      <path d="M15 17v-6h6" />
    </template>
    <template v-else-if="type === 'LIBRARY'">
      <path d="M10 9h8a6 6 0 0 1 6 6v24a6 6 0 0 0-6-6h-8V9Z" />
      <path d="M38 9h-8a6 6 0 0 0-6 6v24a6 6 0 0 1 6-6h8V9Z" />
    </template>
    <template v-else-if="type === 'CREATIVE'">
      <path d="m12 35 3-10L32 8l8 8-17 17-11 2Z" />
      <path d="m15 25 8 8M28 12l8 8" />
    </template>
    <template v-else-if="type === 'SOCIAL'">
      <path d="M11 22v-5a5 5 0 0 1 5-5h16a5 5 0 0 1 5 5v5" />
      <path d="M8 22a4 4 0 0 1 4 4v8h24v-8a4 4 0 1 1 4 4v9H8v-9a4 4 0 0 1 0-8Z" />
    </template>
    <template v-else-if="type === 'COFFEE'">
      <path d="M10 14h24v13a10 10 0 0 1-10 10h-4a10 10 0 0 1-10-10V14Z" />
      <path d="M34 19h3a5 5 0 0 1 0 10h-3M8 41h30" />
    </template>
    <template v-else-if="type === 'KPOP'">
      <path d="M29 9v23a7 7 0 1 1-4-6.3V14l14-3v17a7 7 0 1 1-4-6.3V9l-6 1.3Z" />
      <path d="m10 11 1.5 3.5L15 16l-3.5 1.5L10 21l-1.5-3.5L5 16l3.5-1.5L10 11Z" />
    </template>
    <template v-else>
      <path d="M9 39V13l15-6 15 6v26H9Z" />
      <path d="M17 19h4v4h-4zM27 19h4v4h-4zM17 28h4v4h-4zM27 28h4v4h-4zM22 39v-6h4v6" />
    </template>
  </svg>
</template>

<script setup lang="ts">
import type { RoomType } from "../shared/types"
defineProps<{ type: RoomType }>()
</script>

<style scoped>
.room-icon-svg { width: 32px; height: 32px; stroke: currentColor; stroke-width: 2.6; stroke-linecap: round; stroke-linejoin: round; }
</style>
